<template>
  <ul class="text-black">
    <li v-for="item in items">
      <span class="name font-red">{{item.content}} </span>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          content: "Video 1"
        },
        {
          content: "Video 2"
        }
      ]
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/variables.scss";
</style>



// WEBPACK FOOTER //
// Videos.vue?4f7c680d